<script lang="ts" setup>
import { type CSSProperties, computed } from 'vue'

defineOptions({ name: 'SdSvgIcon' })

const props = defineProps({
    prefix: { type: String, default: 'icon' },
    name  : { type: String                  },
    size  : { type: Number                  },
    color : { type: String                  },
})

const iconStyle$ = computed(() => {
    const styles: CSSProperties = {}

    if (props.size) {
        styles.width = `${props.size}px`
        styles.height = `${props.size}px`
    }

    if (props.color)
        styles.color = props.color

    return styles
})

</script>

<template>
    <svg :class="[$attrs.class, 'sd-icon sd-svg-icon']" :style="iconStyle$" aria-hidden="true">
        <use :xlink:href="`#${props.prefix}-${props.name}`" />
    </svg>
</template>
